module.exports = __webpack_public_path__ + "static/media/logo.73e33f4c.svg";